import React from 'react';
import PropTypes from 'prop-types';
import { ecommerce } from 'config/constants';
import style from './style.scss';//NOSONAR


const MapTracking = ({ data }) => {
    let urlTrancking = data && data.value && data.value.url;
    return (
        <>
            <div className="container-maps-track">
                <iframe src={urlTrancking} className={'map-iframe'}  title={ecommerce.metaTitle}/>
            </div>
        </>
    )
}

MapTracking.propTypes = {
    data: PropTypes.object
};

export default MapTracking;